// src/features/blogs/public/MissionVision.jsx
import { Link } from 'react-router-dom';
import { useGetBlogBySlugQuery } from '../blogsApiSlice';

const blocks = [
  { slug: 'our-mission', titleFallback: 'Our Mission' },
  { slug: 'our-vision', titleFallback: 'Our Vision' },
];

function SectionCard({ data, titleFallback, to }) {
  if (!data) {
    // graceful placeholder (if not found or still loading state handled outside)
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <h2 className="text-xl font-semibold text-gray-900">{titleFallback}</h2>
        <p className="mt-2 text-gray-600">Content is being prepared.</p>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
      {data.coverImageUrl && (
        <img
          src={data.coverImageUrl}
          alt={data.title}
          className="h-56 w-full object-cover"
          loading="lazy"
        />
      )}
      <div className="p-6">
        <h2 className="text-xl font-semibold text-gray-900">{data.title || titleFallback}</h2>
        {data.summary && <p className="mt-3 text-gray-700">{data.summary}</p>}
        <div className="mt-4">
          <Link
            to={to}
            className="inline-flex items-center gap-1 rounded-xl border px-4 py-2 text-gray-800 hover:bg-gray-50"
          >
            Read full article →
          </Link>
        </div>
      </div>
    </div>
  );
}

export default function MissionVision() {
  const { data: mission, isLoading: loadingMission, isError: errMission } =
    useGetBlogBySlugQuery('our-mission');
  const { data: vision, isLoading: loadingVision, isError: errVision } =
    useGetBlogBySlugQuery('our-vision');

  const isLoading = loadingMission || loadingVision;
  const hadError = errMission || errVision;

  return (
    <section className="mx-auto max-w-6xl px-4 py-10">
      <header className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900">Our Mission & Vision</h1>
        <p className="mt-2 text-gray-600">
          Technology made simple (Mudah), in harmony (Selaras) with people and business.
        </p>
      </header>

      {isLoading ? (
        <div className="text-gray-500">Loading…</div>
      ) : hadError ? (
        <div className="text-red-600">
          Unable to load Mission & Vision at the moment. Please try again shortly.
        </div>
      ) : (
        <div className="grid gap-8 md:grid-cols-2">
          <SectionCard
            data={mission}
            titleFallback={blocks[0].titleFallback}
            to="/blogs/our-mission"
          />
          <SectionCard
            data={vision}
            titleFallback={blocks[1].titleFallback}
            to="/blogs/our-vision"
          />
        </div>
      )}
    </section>
  );
}
